"use client";

import Script from "next/script";
import { useEffect } from "react";

import { useConsent } from "@/features/consent/useConsent";

import { applyTikTokConsent } from "./consent";
import { tiktokPixelSnippet } from "./pixel-snippet";

// Public, brand-specific pixel id. Absent → the pixel never loads (mirrors the
// PostHog token gate), so previews and local dev stay clean unless configured.
const PIXEL_ID = process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID;

/**
 * Loads the TikTok advertising pixel, gated behind the `marketing` consent
 * category. The pixel snippet is only injected once consent is granted, so no
 * TikTok cookie is set before the visitor opts in. If they later revoke
 * consent the <Script> unmounts, and the effect below tells the still-loaded
 * `ttq` to stop, so no further data is sent for the rest of the session.
 */
export function TikTokPixel() {
  const { marketing, ready } = useConsent();

  useEffect(() => {
    if (!ready) {
      return;
    }
    applyTikTokConsent(marketing ?? "denied");
  }, [marketing, ready]);

  if (!ready || !PIXEL_ID || marketing !== "granted") {
    return null;
  }

  return (
    <Script id="tiktok-pixel" strategy="afterInteractive">
      {tiktokPixelSnippet(PIXEL_ID)}
    </Script>
  );
}
